import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../../_services/auth.service';
import { DatePipe } from '@angular/common';
import { AppComponent } from 'src/app/app.component';
import { HomeComponent } from '../home.component';
declare var $;

@Component({
  selector: 'app-login-history',
  templateUrl: './login-history.component.html',
  styleUrls: ['./login-history.component.css'],
})
export class LoginHistoryComponent implements OnInit {
  TotalLogin: any;
  HighestLoginBy: any;
  HighestLogin: any;
  TodayTotalLogin: any;
  dataTable: any;
  dtOptions: any;
  tableData = [];
  @ViewChild('dataTable', { static: true }) table;

  constructor(
    private authService: AuthService,
    private datepipe: DatePipe,
    private appComponent: AppComponent,
    private homeComponent: HomeComponent
  ) {}

  ngOnInit() {
    this.authService.isAuthenticated();
    this.appComponent.setTitle('Login History');

    this.authService.pageVisit().subscribe(
      () => {},
      (error) => {
        console.log(error);
      }
    );

    this.getLoginHistoryData();
  }

  SetInactive() {
    this.homeComponent.SetInactive();
  }

  getLoginHistoryData() {
    this.authService.getLoginHistoryData().subscribe(
      (data) => {
        this.TotalLogin = data.totallogin;
        this.HighestLoginBy = data.highestloginby;
        this.HighestLogin = data.highestlogin;
        data.loginlist.forEach((value, index) => {
          value.index = index + 1;
          value.login = this.appComponent.UTCToLocalTime(value.login);
          if (value.logout != null) {
            value.logout = this.appComponent.UTCToLocalTime(value.logout);
          }
          value.date = this.datepipe.transform(value.login, 'yyyy-MM-dd');
        });
        const date = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
        this.TodayTotalLogin = data.loginlist.filter(
          (x) => x.date === date
        ).length;
        this.tableData = data.loginlist;
        this.dtOptions = {
          data: this.tableData,
          columns: [
            { title: '#', data: 'index' },
            { title: 'Name', data: 'name' },
            { title: 'Email', data: 'email' },
            { title: 'Login', data: 'login' },
            { title: 'Logout', data: 'logout' },
            { title: 'IP Address', data: 'ip' },
          ],
          responsive: true,
          autoWidth: false,
        };
      },
      (err) => {
        console.log(err);
      },
      () => {
        this.dataTable = $(this.table.nativeElement);
        this.dataTable.DataTable(this.dtOptions);
      }
    );
  }
}
